module.exports = __webpack_public_path__ + "img/curve-1.44869772.svg";